export function fixLockedSound(game: Phaser.Game): void {
  if (game.device.android && game.device.chrome && game.device.chromeVersion >= 55) {
      game.sound.touchLocked = true;
      

      const soundManager = game.sound;
      let unlockedSource: any;

      // @ts-ignore
      game.input.addTouchLockCallback(function() {
        if (soundManager.noAudio || !soundManager.touchLocked || unlockedSource !== null) {
          console.log('no need to unlock');
          return true;
        }
        console.log('usingWebAudio: ', soundManager.usingWebAudio);
        if (soundManager.usingWebAudio) {
          var buffer = soundManager.context.createBuffer(1, 1, 22050);
          unlockedSource = soundManager.context.createBufferSource();
          unlockedSource.buffer = buffer;
          unlockedSource.connect(soundManager.context.destination);

          if (unlockedSource.start === undefined) {
            unlockedSource.noteOn(0);
          } else {
            unlockedSource.start(0);
          }

          //Hello Chrome 55!
          if (unlockedSource.context.state === 'suspended') {
            unlockedSource.context.resume();
          }
        }

        //  We can remove the event because we've done what we needed (started the unlock sound playing)
        return true;
      }, game.sound, true);
    }
}